import { AxiosResponse } from "axios";

import { PaginationRequest } from "@/main/models/common/paginationRequest";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { Result } from "@/main/models/common/resultResponse";
import {
	GetCancelableQuoteItemsRequest,
	GetPartInfosByQuoteRequest,
	GetPredictRequest,
	MapPartRequest,
} from "@/main/models/request";
import {
	CancelableQuoteItemsResponse,
	MappingPartDetailViewResponse,
	PartInfoByQuoteResponse,
	QuoteItemMappingPartViewReponse,
} from "@/main/models/response";

export abstract class IQuoteItemApi {
	abstract getMappingParts(
		request: PaginationRequest,
	): Promise<AxiosResponse<PaginationResponse<QuoteItemMappingPartViewReponse>>>;

	abstract getMappingPartDetail(
		request: GetPredictRequest,
	): Promise<AxiosResponse<Result<MappingPartDetailViewResponse>>>;

	abstract saveMappingPart(request: MapPartRequest): Promise<AxiosResponse<Result<void>>>;

	abstract getCancelableQuoteItems(
		request: GetCancelableQuoteItemsRequest,
	): Promise<AxiosResponse<Result<CancelableQuoteItemsResponse>>>;

	abstract saveMappingPartDiscarted(request: MapPartRequest): Promise<AxiosResponse<Result<void>>>;

	abstract getPartInfosByQuote(
		request: GetPartInfosByQuoteRequest,
	): Promise<AxiosResponse<Result<PartInfoByQuoteResponse[]>>>;
}
